import { Controller } from 'stimulus';

export default class extends Controller {
  static targets = ['branch', 'map'];

  connect() {
    dataLayer.push({
      'ecommerce': {
        'currencyCode': 'RUB',
        'detail': {
          'products': [
            {
              'brand': this.data.get('brand'),
              'id': this.data.get('id'),
              'name': this.data.get('name'),
              'price': this.data.get('price')
            }
          ]
        }
      }
    });
  }
}
